import React, { useEffect, useState } from "react";
import { PiDotsSixVertical } from "react-icons/pi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ModalForm from "./Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromSection,
  setActiveSection,
} from "../../../Redux/Store/Slices/sectionSlice";
import AddContentModal from "./AddContentModal";
import { updateSection } from "../../../Redux/Store/Slices/projectReducer";
import {
  buildProductImageUrl,
  getFallbackImageUrl,
  getProductImageUrl,
} from "../../../utils/productImage";

const NestedSection = ({ nestedSection, level = 0 }) => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(true);
  const [selectedChoiceId, setSelectedChoiceId] = useState(null);
  const { active_section } = useSelector((state) => state.section);
  const [localProducts, setLocalProducts] = useState(() =>
    Array.isArray(nestedSection.products) ? [...nestedSection.products] : []
  );

  const toggleSection = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    setSelectedChoiceId(null);
  }, [nestedSection?.id]);

  useEffect(() => {
    setLocalProducts(
      Array.isArray(nestedSection.products) ? [...nestedSection.products] : []
    );
  }, [nestedSection.products]);

  const handleAddProductModal = (event, section) => {
    event.preventDefault();
    console.log("nested section:", section);
    
    // S'assurer que la section a un tableau products initialisé et marquer comme section imbriquée
    const normalizedProducts = Array.isArray(localProducts) ? [...localProducts] : [];

    const sectionWithProducts = {
      ...section,
      products: normalizedProducts,
      contents: Array.isArray(section.contents) ? [...section.contents] : [],
      isNestedSection: true,
      initialProductIds: normalizedProducts
        .map((product) => product.product?.id || product.id)
        .filter(Boolean),
    };
    
    dispatch(setActiveSection(sectionWithProducts));
  };

  const handleRemoveProduct = (product) => {
    console.log('handleRemoveProduct appelé avec:', product);
    
    const productContent = {
      id: product.id,
      product_type: product.product_type || "",
      product: product.product
    };
    
    dispatch(removeFromSection(productContent));

    const updatedProducts = localProducts.filter(
      (item) => item.product?.id !== product.product?.id
    );

    setLocalProducts(updatedProducts);

    const updatedNestedSection = {
      ...nestedSection,
      products: updatedProducts,
    };

    dispatch(updateSection(updatedNestedSection));
  };

  const handleChoiceSelect = (choiceItem) => {
    setSelectedChoiceId((prevChoiceId) => {
      const isSameChoice = prevChoiceId === choiceItem.id;

      console.log(
        `Choice item ${choiceItem.label} ${
          isSameChoice ? "deselectionne" : "selectionne"
        } pour la section imbriquee ${nestedSection.id}`
      );

      return isSameChoice ? null : choiceItem.id;
    });
  };

  const handleShowSelectedProducts = (selectedProducts) => {
    const productsList = Array.isArray(selectedProducts) ? selectedProducts : [];

    console.log(`${productsList.length} produit(s) ajouté(s) à la section imbriquée ${nestedSection.id}`);

    setLocalProducts(productsList);

    // Mettre à jour la section imbriquée avec les produits sélectionnés
    const updatedNestedSection = {
      ...nestedSection,
      products: productsList,
    };

    dispatch(updateSection(updatedNestedSection));
  };

  const getIndentStyle = () => {
    return {
      marginLeft: `${level * 20}px`,
      borderLeft: level > 0 ? '2px solid #e0e0e0' : 'none',
      paddingLeft: level > 0 ? '10px' : '0'
    };
  };

  return (
    <div style={getIndentStyle()} className="nested-section">
      <div className="border-circle rounded" id={`nested-section-${nestedSection.id}`}>
        <div className="px-2 d-flex mb-3 border-btm">
          <div className="d-flex me-auto">
            <button
              type="button"
              className="p-col-2 fs-3 border-0 bg-white"
            >
              <PiDotsSixVertical />
            </button>
            <div>
              <p className="section-text pt-3 ps-1">
                {level > 0 && '↳ '}Nested Section: {nestedSection.name}
                {localProducts.length > 0 && (
                  <span className="badge bg-success ms-2">
                    {localProducts.length} produit(s)
                  </span>
                )}
              </p>
              <small className="text-muted">
                Type: {nestedSection.section_type} | Code: {nestedSection.code}
              </small>
            </div>
          </div>
          <div className="p-2">
            <button
              type="button"
              className="btn fs-italic"
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal-${nestedSection.id}`}
              onClick={(event) => handleAddProductModal(event, nestedSection)}
            >
              <FaPlus /> Add Content
            </button>
            <AddContentModal />
          </div>
          <div className="p-2">
            <button
              onClick={toggleSection}
              type="button"
              className="btn p-col-2 fs-3"
            >
              {isActive ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </button>
          </div>
        </div>

        {isActive && (
          <div>
            {(() => {
              const choiceItems =
                (Array.isArray(nestedSection.choice_items) && nestedSection.choice_items.length > 0
                  ? nestedSection.choice_items
                  : Array.isArray(nestedSection.choices)
                  ? nestedSection.choices
                  : []) || [];

              if (choiceItems.length === 0) {
                return null;
              }

              return (
              <div className="choice-items-wrapper ms-3 me-3">
                <h6 className="ms-1 mb-3 text-muted d-flex align-items-center">
                  <i className="fas fa-check-square me-2" />
                  Choix disponibles ({choiceItems.length})
                </h6>
                <div className="choice-items-grid">
                  {choiceItems.map((choice) => {
                    const isSelected = selectedChoiceId === choice.id;
                      const hasChildren =
                        Array.isArray(choice.children) &&
                        choice.children.length > 0;

                      const linkedProductImage =
                        getProductImageUrl(choice.linked_product) ||
                        getProductImageUrl(choice.product_ref);
                      const rawChoiceImage =
                        buildProductImageUrl(choice.image) ||
                        buildProductImageUrl(choice.profile_image);
                      const finalChoiceImage =
                        linkedProductImage ||
                        rawChoiceImage ||
                        getFallbackImageUrl();

                    return (
                      <button
                        key={choice.id}
                        type="button"
                        className={`choice-card ${isSelected ? "selected" : ""}`}
                        onClick={() => handleChoiceSelect(choice)}
                      >
                        <div className="choice-card-header">
                          <span className="choice-card-label">{choice.label}</span>
                          {isSelected && (
                            <span className="choice-card-badge">Selectionne</span>
                          )}
                        </div>
                        {finalChoiceImage && (
                          <div className="choice-card-image">
                            <img src={finalChoiceImage} alt={choice.label} />
                          </div>
                        )}
                        {choice.help_text && (
                          <p className="choice-card-help">{choice.help_text}</p>
                        )}
                        <div className="choice-card-meta">
                          <span>Code : {choice.code}</span>
                          {choice.add_quantities && (
                            <span className="choice-card-quantity">
                              Quantite ajustable
                            </span>
                          )}
                          {hasChildren && (
                            <span className="choice-card-children">
                              {choice.children.length} option(s) associee(s)
                            </span>
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>
              );
            })()}
            {/* Afficher les produits de cette section imbriquée */}
                {localProducts.length > 0 && (
              <section>
                <div className="row m-3">
                      {localProducts.map((product) => (
                    <div key={product.product.id} className="col-6 mb-4 mt-1">
                      <div
                        className="border d-flex justify-content-between"
                        style={{ width: "100%" }}
                      >
                        <div className="d-flex pt-2 px-1">
                          <div>
                            <img
                              className=""
                              src={
                                getProductImageUrl(product.product) ||
                                getFallbackImageUrl()
                              }
                              alt={product.product.name}
                              style={{ width: "75px", height: "75px" }}
                            />
                          </div>
                          <div className="design-text px-3">
                            <span>{product.product.name}</span>
                            <br />
                            <p className="p-col mt-1">
                              <span className="p-6-d me-4">
                                Price: £{product.product.price}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="position-relative me-3">
                          <div className="text-top d-flex justify">
                            <button
                              type="button"
                              className="btn bg-warning-subtle text-remove fw-bold fst-italic"
                            >
                              <Link
                                className="p-col text-remove"
                                onClick={() => handleRemoveProduct(product)}
                              >
                                Remove
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Afficher les sections imbriquées récursivement */}
            {nestedSection.sections && nestedSection.sections.length > 0 && (
              <div className="nested-sections-container">
                {nestedSection.sections.map((subNestedSection) => (
                  <NestedSection 
                    key={subNestedSection.id} 
                    nestedSection={subNestedSection} 
                    level={level + 1}
                  />
                ))}
              </div>
            )}

            <hr className="ms-4" style={{ width: "95%" }} />
            <div>
              <div>
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target={`#exampleModal-${nestedSection.id}`}
                  className="rounded border-dash mb-4 ms-4 pe-auto text-center fw-bold fst-italic py-2 bg-white p-6-d"
                  style={{ width: "95%" }}
                  onClick={(event) => handleAddProductModal(event, nestedSection)}
                >
                  Add Product
                </button>
              </div>
              <ModalForm
                sectionId={nestedSection.id}
                onShowSelectedProducts={handleShowSelectedProducts}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NestedSection;
